// extracted by mini-css-extract-plugin
export default {"wrapper":"KanbanTable_wrapper__nfGX+","item__wrapper":"KanbanTable_item__wrapper__jtn6s"};